import { useApiMutation, useApiQuery } from "@/hooks/use-api"
import { Tag, TagCreate } from "@/models/tag"
import { hasSelectedWorkspace } from "./core"

export const useTags = () =>
	useApiQuery<Tag[]>(
		{
			url: "tags/find",
			method: "POST",
			data: { monitoring: true },
		},
		{ enabled: hasSelectedWorkspace(), staleTime: 2 * 60 * 1000 }
	)

export const useCreateTag = () =>
	useApiMutation<Tag, TagCreate>({ url: "tags", method: "POST" })

export const useDeleteTag = () =>
	useApiMutation<{}, {}, { id: string }>({
		url: `tags/{id}`,
		method: "DELETE",
	})

export const useUpdateTag = () =>
	useApiMutation<Tag, TagCreate, { id: string }>({
		url: `tags/{id}`,
		method: "PATCH",
	})
